import * as React from "react";
const SvgHistory = (props) => (
  <svg
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.98 1.932A5.833 5.833 0 1 1 3.051 8.48l.73.877a.5.5 0 1 0 .769-.64L2.886 6.72a.675.675 0 0 0-.052-.055.498.498 0 0 0-.668 0l-.004.004a.504.504 0 0 0-.049.051L.45 8.716a.5.5 0 0 0 .768.64l.816-.979a6.834 6.834 0 1 0 1.707-5.23.5.5 0 1 0 .745.667A5.833 5.833 0 0 1 7.98 1.932Zm.853 2.27a.5.5 0 0 1 .5.5v2.834h1.834a.5.5 0 0 1 0 1H8.833a.5.5 0 0 1-.5-.5V4.703a.5.5 0 0 1 .5-.5Z"
      fill={props.color}
    />
  </svg>
);
export default SvgHistory;
